import { FIRST_MODULE_ALIAS } from '@/domain/services/installation/modules/menu';

const EngineeringAsset = () => import(/* webpackChunkName: "engineeringAsset" */ '../EngineeringAsset');
const EngineeringIndex = () => import(/* webpackChunkName: "engineering" */ '../index');
const Module = () => import(/* webpackChunkName: "modules" */ '../modules/index');

export default {
  path: 'engenharia',
  name: 'engineering',
  component: EngineeringIndex,
  meta: {
    breadcrumb: {
      name: 'page-name.engineering',
    },
  },
  redirect: {
    name: 'monitoring',
  },
  children: [
    {
      path: ':assetId',
      name: 'monitoring.engineering.asset',
      component: EngineeringAsset,
      redirect: to => ({
        name: 'monitoring.engineering.module',
        params: {
          ...to.params,
          assetModuleId: FIRST_MODULE_ALIAS,
        },
      }),
      children: [
        {
          path: 'modulo/:assetModuleId',
          name: 'monitoring.engineering.module',
          component: Module,
        },
      ],
    },
  ],
};
